import {
    getRoutesImportLoading,
    getRoutesImportReject,
    getRoutesImportRequest,
    getRoutesImportSuccess
} from "../../actions/notifications/getAllRoutesImport";

export const getRoutesImport = (formData) => async (dispatch, getState) => {
    dispatch(getRoutesImportLoading());
    try {
        const { data } = await getRoutesImportRequest(formData, getState);
        dispatch(getRoutesImportSuccess(data))
    } catch (error) {
        dispatch(getRoutesImportReject(error))
    }
    return Promise.resolve();
};